import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export function ICLogo({ width, height, className }: ISvgIcon): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 30 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.60266 0L0.0252894 2.88445V8.65796V14.4315V20.2004V25.9739L0.113802 26.0291L0 26.1027L10.4319 32.7273L4.74597 23.4897L4.60266 23.255V23.0894V17.3159V11.5424V5.77351L9.18426 8.65796L13.7658 11.5424V5.77351L9.18426 2.88445L4.60266 0Z"
        fill="#19AB4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7257 13.7275L16.0546 16.0185V21.7874L19.7257 19.0272V13.7275Z"
        fill="#19AB4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5339 28.6559L29.8162 26.1027L29.7024 26.0291L29.7951 25.9739V20.2004V14.4315V8.65796V2.88445L25.2135 0L20.6319 2.88445L16.0546 5.77351V11.5424L20.6319 8.65796L25.2135 5.77351V11.5424V17.3159V23.0894V23.3562L18.7057 32.7273L25.2135 28.8491V28.8583L25.5339 28.6559Z"
        fill="#19AB4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70264 19.2298L13.7658 21.7876V16.0187L9.70264 13.4792V19.2298Z"
        fill="#19AB4A"
      />
    </svg>
  );
}
